import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
const bonuses = [{
  label: 'BONO 1',
  title: 'Manual Maestro de Motores Eléctricos',
  desc: 'Todo sobre conexión, bobinado y mantenimiento de motores monofásicos y trifásicos.',
  image: 'https://cdn.magicpatterns.com/uploads/gA8CZbCQmLZyVwwy1LEoz8/motores_electricos.webp'
}, {
  label: 'BONO 2',
  title: 'Guía Pro de Energía Solar Fotovoltaica',
  desc: 'Aprende a instalar paneles, inversores y sistemas de energía limpia desde cero.',
  image: 'https://cdn.magicpatterns.com/uploads/9GcN6LckJ3U6rTNBRYKwkR/energia_solar_pro.webp'
}, {
  label: 'BONO 3',
  title: 'Biblioteca de 150 Diagramas Técnicos',
  desc: 'Esquemas de tableros, conexiones de comandos y simbología universal para consulta rápida.',
  image: 'https://cdn.magicpatterns.com/uploads/7jQ6CYDYZ1hNGeSvCYnjvJ/diagramas_y_planos.webp'
}, {
  label: 'BONO 4',
  title: 'Plantillas de Presupuestos y Cobros',
  desc: 'La herramienta para calcular materiales y mano de obra sin perder dinero.',
  image: 'https://cdn.magicpatterns.com/uploads/qmHKi4nMPHvNyBjiJhTzHS/presupuesto_electrico.webp'
}, {
  label: 'BONO 5',
  title: 'Manual de Reparación de Electrodomésticos',
  desc: 'Aprende a diagnosticar y reparar herramientas y equipos eléctricos para ofrecer un servicio más completo.',
  image: 'https://cdn.magicpatterns.com/uploads/rWpo2eZvtET4dD74eGUByR/reparaciones_pro.webp'
}];
export function Bonuses() {
  return <section className="py-12 md:py-20 px-4 bg-navy relative overflow-hidden" data-id="element-15">
      {/* Technical background pattern */}
      <div className="absolute inset-0 bg-[radial-gradient(#1e293b_1px,transparent_1px)] [background-size:22px_22px] opacity-30" data-id="element-16" />

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-17">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10 md:mb-16" data-id="element-18">
          <div className="inline-flex items-center gap-2 bg-electric text-navy font-black tracking-widest text-xs md:text-sm uppercase mb-6 px-4 py-2 rounded" data-id="element-19">
            <Gift size={18} data-id="element-20" />
            <span data-id="element-21">Bonos Estratégicos</span>
          </div>
          <h2 className="text-3xl md:text-5xl font-black text-white mb-4 leading-tight" data-id="element-22">
            5 BONOS ESTRATÉGICOS <br className="hidden md:block" data-id="element-23" />
            <span className="text-electric" data-id="element-24">(INCLUIDOS GRATIS)</span>
          </h2>
          <p className="text-slate-300 font-semibold text-base md:text-xl max-w-3xl mx-auto leading-relaxed" data-id="element-25">
            Complementos técnicos que te ayudan a consultar mejor, organizar tus
            presupuestos y ofrecer un servicio más profesional.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8" data-id="element-26">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white p-6 rounded border border-slate-200 shadow-lg relative flex flex-col group hover:-translate-y-1 transition-transform duration-300" data-id="element-27">
              {/* GRATIS badge */}
              <span className="absolute top-4 right-4 z-20 bg-electric text-navy text-[10px] md:text-xs font-black px-3 py-1 rounded uppercase tracking-widest shadow-md" data-id="element-28">
                Gratis
              </span>

              {/* Bonus product image */}
              <div className="relative flex items-center justify-center h-44 md:h-48 mb-5 rounded bg-light/60" data-id="element-29">
                <img src={bonus.image} alt={bonus.title} loading="lazy" decoding="async" className="h-full w-auto max-w-full object-contain mix-blend-multiply drop-shadow-md group-hover:scale-105 transition-transform duration-300" data-id="element-30" />
              </div>

              <span className="text-electric bg-navy inline-block w-fit text-[10px] font-black px-2 py-1 rounded uppercase tracking-widest mb-3" data-id="element-31">
                {bonus.label}
              </span>
              <h3 className="text-lg md:text-xl font-black text-navy mb-2 leading-tight" data-id="element-32">
                {bonus.title}
              </h3>
              <p className="text-slate-600 text-sm md:text-base font-medium leading-relaxed" data-id="element-33">
                {bonus.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}